import { render, staticRenderFns } from "./key-benefits.vue?vue&type=template&id=01a25c87&scoped=true&"
import script from "./key-benefits.vue?vue&type=script&lang=ts&"
export * from "./key-benefits.vue?vue&type=script&lang=ts&"
import style0 from "./key-benefits.vue?vue&type=style&index=0&id=01a25c87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a25c87",
  null
  
)

export default component.exports